import type { ZabitBridge } from '../../renderer/src/global';

/**
 * Apple ile Giriş — yalnızca iOS uygulamasında (mobile/src/shims/appleSignIn.ts).
 * Web'de yok.
 */
export const appleSignIn: ZabitBridge['appleSignIn'] = undefined;
